import {RouteConfig} from 'vue-router';
import Workplaces from '../settings/pages/Workplaces.vue';

export default [
    
] as RouteConfig[];